import type { FaireProductEntity } from "../../entity_types/product";

export const p_n4qkmcwx8a: FaireProductEntity = {
  token: "p_n4qkmcwx8a",
  type: "product",
  name: "Tumbled Stone Blue Kyanite Rough",
  brandToken: "b_pfe5z89pnk",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3547bf6ea393f14da21446ef50e58866d5af85945e08faa98f05fb5f5c348369.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/497dc449e30ca5ae246c2a2b7c7abe6b73743f0af6972c7da2d4831bfe33eb27.jpeg",
    "https://cdn.faire.com/fastly/dbc2b1dd720e6869431ec2b9273b2ca6afad36286b57c6cb5c8bb52bc0e21578.jpeg",
    "https://cdn.faire.com/fastly/89cb49bee9aee52b7949b15124bf853dff688c6930ba2f7d3d24dc8f513874d5.jpeg",
  ],
  priceDollars: 5.53,
  description:
    "As Vrinda, we proudly present our Tumbled Stone Blue Kyanite Rough. This natural raw stone is a spiritual crystal that supports mindfulness and well-being. With its unique healing properties, it is perfect for those seeking balance, peace, and spiritual connection. As a family-owned business based in Miami, we are dedicated to creating and distributing products that promote sacred living. This Blue Kyanite Rough stone is just one of our many offerings that reflect our commitment to the global wellness community.",
  tags: [],
  msrpDollars: 11.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:07.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
